const openModalButtons = document.querySelectorAll(
  ".landing-hero-omega__video-wrapper button"
);
const modal = document.querySelector(".landing-hero-omega__modal");
const video = modal.querySelector("video");
const modalCloseButton = modal.querySelector(
  ".landing-hero-omega__modal-close"
);

if (openModalButtons) {
  openModalButtons.forEach((button) =>
    button.addEventListener("click", openModal)
  );
}
// const reviewWidget = document.querySelector(".landing-hero-omega__rating-tags");
// if(reviewWidget){
//   reviewWidget.addEventListener("click", scrollToReviews)
// }
// function scrollToReviews(e){
//   // e.preventDefault();
//   // const reviews = document.querySelector(".main-reviews");

//   // if(reviews){
//   //   window.scrollTo(0, reviewWidget.offsetTop);
//   // }
// }
modalCloseButton.addEventListener("click", closeModal);
modal.addEventListener("click", (e) => {
  const isVideo = e.target.closest("video");
  if (!isVideo) {
    closeModal();
  }
});
document.addEventListener("keydown", function (event) {
  if (event.key === "Escape") {
    closeModal();
  }
});

function openModal() {
  modal.style.zIndex = "3";
  modal.classList.remove("v-hidden");
  video.currentTime = 0;
  video.play();
}
function closeModal() {
  modal.classList.add("v-hidden");
  if (!video.paused) {
    video.pause();
  }
  modal.style.zIndex = "0";
}

const heroSwiper = new Swiper(".landing-hero-omega__mySwiper", {
  loop: true,
  slidesPerView: 1,
  navigation: {
    nextEl: ".landing-hero-omega__swiper-button-next",
    prevEl: ".landing-hero-omega__swiper-button-prev",
  },
  pagination: {
    el: ".landing-swiper-pagination.swiper-pagination",
    clickable: true,
    type: "bullets",
    renderBullet: function (index, className) {
      return (
        '<span class="' +
        className +
        ' landing-swiper-bullet">' +
        (index + 1) +
        "</span>"
      );
    },
  },
  keyboard: true,
});
